import React, { useCallback, useEffect, useState } from "react";
import { StaticRouter } from "react-router-dom/server";
import { Fiche } from "../Fiche/Fiche";
import { Filter } from "./Filter/Filter";
import { Popup } from "../Popup/Popup";
import { debounce } from "lodash";
import { Button } from "../Button/Button";
import { Loading } from "./Loading/Loading";
import { useMemo } from "react";

const navigate = (url) => {
  if (
    window &&
    window.location &&
    window.location.pathname &&
    window.location.pathname !== url
  ) {
    window.history.pushState({}, "", url);
  }
};

const getCurrentPath = () => {
  let curPath = `${window.location.pathname.split("/fiche/")[0]}`;
  if (!curPath.endsWith("/")) {
    curPath = curPath + "/";
  }
  return curPath;
};

export const FicheLijst = (props) => {
  const apiUrl = "/umbraco/api/";
  //#region  states

  const [ficheData, setFicheData] = useState({
    folderId: null,
    themas: [],
    fiches: [],
    type: null,
    totalCount: 0,
    filter: null,
    pageId: null,
    culture: null,
  });

  const [rendered, setRendered] = useState(0);
  const [currentPopupData, setCurrentPopupData] = useState(null);

  const [pathName, setPathName] = useState("");
  const [ficheTypeClassName, setFicheTypeClassName] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [loadAnimations, setLoadAnimations] = useState(true);

  //#endregion states

  //#region functions

  const startLoading = () => {
    setIsLoading(true);
  };

  const stopLoading = () => {
    setIsLoading(false);
  };

  //Clear popup state
  const closePopup = () => {
    setCurrentPopupData(null);
    navigate(getCurrentPath());
    document.querySelector("html").classList.remove("u-noscroll");
  };

  const checkDetailView = () => {
    if (
      props.urlPopup &&
      ficheData.type &&
      `fiche${props.urlPopup.type}` === ficheData.type.toLowerCase()
    ) {
      if (props.urlPopup.alias) {
        openPopup(props.urlPopup.alias);
        props.urlPopup = null;
        setLoadAnimations(false);
      }
    } else if (window.location.href.includes(`/fiche/`) && ficheData.type) {
      var type = window.location.href.split("/fiche/")[1].split("/")[0];
      var alias = window.location.href.split("/fiche/")[1].split("/")[1];
      if (
        type &&
        alias &&
        `fiche${type}`.toLowerCase() == ficheData.type.toLowerCase()
      ) {
        openPopup(alias);
        setLoadAnimations(false);
      } else {
        closePopup();
      }
    } else if (currentPopupData) {
      closePopup();
    }
  };

  //#endregion functions

  //#region callbacks
  const printComponentToPdf = useCallback(async (urlSegment) => {
    let filename = "ficheDetail";

    fetch(
      `${apiUrl}Fiche/GetDetailPdf/?folderId=${props.folderId}&urlSegment=${urlSegment}`
    )
      .then((response) => {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const responseFilename = response.headers
          .get("content-disposition")
          .match(filenameRegex)[1];
        if (responseFilename) filename = responseFilename;

        return response.blob();
      })
      .then((blob) => {
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        return Promise.reject({ Error: "Something Went Wrong", err });
      });
  }, []);

  // Loads fiche data /w debounce
  const loadFicheData = useCallback(
    debounce((ficheData) => {
      //Load Fiche data
      try {
        var ficheDataToSend = { ...ficheData };
        ficheDataToSend.fiches = [];
        fetch(`${apiUrl}Fiche/GetFiches`, {
          method: "POST",
          headers: new Headers({ "Content-Type": "application/json" }),
          body: JSON.stringify(ficheDataToSend),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.filter.page === 0) {
              if (
                JSON.stringify(ficheData.fiches) !==
                  JSON.stringify(data.fiches) ||
                ficheData.totalCount !== data.totalCount
              ) {
                setFicheData({
                  ...data,
                  pageId: props.pageId,
                  culture: props.culture,
                });
              }

              stopLoading();
            } else {
              var oldFicheData = Object.assign({}, ficheData);
              oldFicheData.fiches = oldFicheData.fiches.concat(data.fiches);
              oldFicheData.totalCount = data.totalCount;
              oldFicheData.filter = data.filter;
              oldFicheData.titleSingle = data.titleSingle;
              oldFicheData.titlePlural = data.titlePlural;
              oldFicheData.pageId = props.pageId;
              oldFicheData.culture = props.culture;
              setFicheData(oldFicheData);
            }
          });
      } catch (error) {
      }
    }, 500),
    []
  );

  //Get detail data & show popup
  const openPopup = useCallback(
    (urlSegment) => {
      //get fiche  data by id
      try {
        fetch(
          `${apiUrl}Fiche/GetFicheDetails?folderId=${props.folderId}&urlSegment=${urlSegment}`
        )
          .then((response) => response.json())
          .then((data) => {
            data.detailContactAddress = props.contactEmailAddress;
            setCurrentPopupData(data);

            let urlType = ficheData.type.replace(/fiche/g, "").toLowerCase();
            navigate(
              getCurrentPath() +
                props.url +
                urlType +
                "/" +
                data.urlSegment +
                "/"
            );
            document.querySelector("html").classList.add("u-noscroll");
          });
      } catch (error) {
      }
    },
    [pathName, ficheData.type]
  );

  //#endregion callbacks

  //#region useEffects

  //On fiche type & parameter render popup
  useEffect(() => {
    if (ficheData.type) {
      checkDetailView();
    }
  }, [ficheData.type]);

  // useEffect(() => {
  //     window.onpopstate = () => checkDetailView();
  // }, [ficheData.type, currentPopupData]);

  //Load filter data
  useEffect(() => {
    const loadFilterData = () => {
      try {
        fetch(
          `${apiUrl}Fiche/GetFilter?folderId=${props.folderId}&culture=${props.culture}&pageId=${props.pageId}`
        )
          .then((response) => response.json())
          .then((data) => {
            setFicheData((prev) => {
              return {
                ...prev,
                filter: data,
                folderId: props.folderId,
                themas: props.themas,
                categories: props.categories,
                type: props.type,
                url: props.url,
                pageId: props.pageId,
                culture: props.culture,
              };
            });
          });
      } catch (error) {
      }
    };
    if (rendered === 0) {
      loadFilterData();
      setRendered(rendered + 1);
      let curPath = getCurrentPath();

      setPathName(curPath);
    }
  }, [rendered]);

  //On filter change update fiche data
  useEffect(() => {
    if (ficheData.filter) {
      // startLoading();
      loadFicheData(ficheData);
    }
  }, [JSON.stringify(ficheData.filter)]);

  const currentPopup = useMemo(() => {
    var data = currentPopupData;
    return (
      <Popup
        data={data}
        printComponentToPdf={printComponentToPdf}
        pathName={pathName}
        type={ficheData.type}
        dictionary={props.dictionary}
        closePopupHandler={closePopup}
      />
    );
  }, [JSON.stringify(currentPopupData), ficheData.type, props.dictionary]);

  //#endregion useEffects
  return (
    <StaticRouter>
      {
        //Add col class to fiche list if amountPerRow is set
        <div
          data-aos={loadAnimations ? "fade-up" : undefined}
          className={`fiche-lijst ${ficheData.type} ${
            ficheData.filter && ficheData.filter.amountPerRow == 4
              ? "c-fichelijst-col-3"
              : ficheData.filter && ficheData.filter.amountPerRow == 5
              ? "c-fichelijst-col-2"
              : ""
          } ${props.bottomSpacing ? props.bottomSpacing : ""}`}
        >
          {
            <div>
              {
                //Check if filter is available
                //Check if themas filter is set (only for fiche publications list)
                ficheData.filter &&
                  ((ficheData.themas && ficheData.themas.length == 0) ||
                    !ficheData.themas) && (
                    <Filter
                      startLoading={startLoading}
                      setFicheData={setFicheData}
                      dictionary={props.dictionary}
                      ficheData={ficheData}
                      amount={ficheData.totalCount}
                    />
                  )
              }
              {!isLoading ? (
                //Render fiches
                <Fiches
                  dictionary={props.dictionary}
                  ficheData={ficheData}
                  setFilterHandler={setFicheData}
                  ficheTypeClassName={ficheTypeClassName}
                  openPopup={openPopup}
                  logoFiches={props.logoFiches}
                />
              ) : (
                <Loading />
              )}
            </div>
          }
        </div>
      }
      {/* Render popup if state contains popup data */}
      {currentPopupData && currentPopup}
    </StaticRouter>
  );
};

//Separated fiches component
const Fiches = (props) => {
  const fiches = useMemo(() => {
    let newFiches = [];

    if (
      props.ficheData &&
      props.ficheData.fiches &&
      props.ficheData.fiches.length > 0
    ) {
      props.ficheData.fiches.forEach((fiche, key) => {
        newFiches.push(
          <Fiche
            dictionary={props.dictionary}
            key={"Fiche_" + key}
            data={fiche}
            ficheType={props.ficheData.type}
            openPopup={props.openPopup}
            isLogoFiche={props.logoFiches}
          />
        );
      });

      return newFiches;
    } else {
      return <h5>{props.dictionary.notFound}</h5>;
    }
  }, [JSON.stringify(props.ficheData.fiches)]);

  return (
    <div className="c-section__body">
      <div className={props.ficheTypeClassName}>
        <div
          className={`c-fiche-wrap ${
            props.logoFiches ? "c-fiche-wrap--logo" : ""
          }  u-clear`}
        >
          {fiches}
        </div>
        {fiches.length < props.ficheData.totalCount && (
          <div className="status ng-scope">
            <div className="buttonContainer">
              <Button
                buttonType={"secondary"}
                label={props.dictionary.loadMore}
                onClick={() =>
                  props.setFilterHandler((prev) => {
                    let filter = { ...prev.filter };
                    filter.page = filter.page + 1;
                    return {
                      ...prev,
                      filter: filter,
                    };
                  })
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
